import { render, staticRenderFns } from "./announcementBannerTab.vue?vue&type=template&id=7beb52f7&scoped=true&lang=pug"
import script from "./announcementBannerTab.vue?vue&type=script&lang=js"
export * from "./announcementBannerTab.vue?vue&type=script&lang=js"
import style0 from "./announcementBannerTab.vue?vue&type=style&index=0&id=7beb52f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beb52f7",
  null
  
)

export default component.exports